module.exports = __webpack_public_path__ + "r-v3/img/video_view_block.74704aa7.svg";